import axios from "axios";
import TemplateEngine from "../3rdparty/template-engine";
import { isNullOrUndefined } from "util";

export default class SearchFilterMusic {
    constructor() {

        if ((this.searchFilters = document.querySelector(".search-filters"))) {
            this.searchFiltersTrigger = document.querySelector(
                ".search-filters-trigger"
            );
            this._toggleFilters();
        }

        if (
            (this.filterItems = document.querySelectorAll(".selection-filter"))
        ) {
            this._activateFilter();
        }

        this.paginationDirection = document.getElementsByClassName(
            "pagination-link--direction"
        );
        this.paginationNumbers = document.getElementsByClassName(
            "pagination-link--number"
        );

        this._initializeEventListeners();

        this.template =
            `<%for(var i in this.results) {%>
                <li class="multi-block multi-block--image multi-block--agenda">
                    <a class="multi-block-link" href="<% this.results[i].Link %>">
                        <div class="multi-block-image-wrapper">
                            <img src="<% this.results[i].Image %>" />
                        </div>
                        <span class="multi-block-event-info button button--blue">
                            <span><% this.results[i].Date %></span>
                            <svg class="icon-clock" viewBox="0 0 20 20">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/static/img/svg/sprite.svg#icon-clock"></use>
                            </svg>
                            <span><% this.results[i].Time %></span>
                        </span>
                        <%if (this.results[i].IsDistrict) {%>
                        <div class="district-label">District</div>
                        <%}%>
                        <div class="multi-block-content">
                            <h4 class="multi-block-title"><% this.results[i].Title %></h4>
                            <span class="multi-block-info"><% this.results[i].City %></span>
                            <span class="multi-block-event-type"><% this.results[i].Types %></span>
                        </div>
                        <svg class="icon-circle-open" viewBox="0 0 72 72">
                            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/static/img/svg/sprite.svg#icon-circle-open"></use>
                        </svg>
                    </a>
                </li>
            <%}%>`;

        this.paginationTemplate = `
            <%if (this.resultCount > 0) { %>
                <a class="pagination-link pagination-link--direction <%if (this.selectedPage === 1) { %> pagination-link--disabled <% } %>" data-direction="back" href="javascript:void(0)">
                    <svg class="icon-arrow" viewBox="0 0 14 12">
                        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/static/img/svg/sprite.svg#icon-arrow"></use>
                    </svg>
                </a>
            <%}%>

            <%if (this.selectedPage - 4 > 1 && 9 - (this.totalPages - this.selectedPage) > 1) { %>
                <div class="pagination-overflow">
                    <span>...</span>
                </div>
            <%}%>

            <%if (this.selectedPage <= 4) { %>
                <%for(var i = 1; i <= this.end; i++) {%>
                    <a class="pagination-link pagination-link--number <%if (this.selectedPage === i) {%> pagination-link--active <%}%>" href="javascript:void(0)"><%i%></a>
                <%}%>
            <%}%>

            <%if (this.selectedPage > 4 && this.totalPages - this.selectedPage > 4) { %>
                <%for(var i = this.selectedPage - 4; i <= this.selectedPage + 4; i++) {%>
                    <a class="pagination-link pagination-link--number <%if (this.selectedPage === i) {%> pagination-link--active <%}%>" href="javascript:void(0)"><%i%></a>
                <%}%>
            <%}%>

            <%if (this.selectedPage > 4 && this.totalPages - this.selectedPage <= 4) { %>
                <%for(var i = this.start; i <= this.totalPages; i++) {%>
                    <a class="pagination-link pagination-link--number <%if (this.selectedPage === i) {%> pagination-link--active <%}%>" href="javascript:void(0)"><%i%></a>
                <%}%>
            <%}%>

            <%if (this.selectedPage + 4 < this.totalPages && this.totalPages > 9) { %>
                <div class="pagination-overflow">
                    <span>...</span>
                </div>
            <%}%>

            <%if (this.resultCount > 0) { %>
                <a class="pagination-link pagination-link--direction  <%if (this.selectedPage === this.totalPages || this.totalPages === 0) { %> pagination-link--disabled <% } %>"  data-direction="forward" href="javascript:void(0)">
                    <svg class="icon-arrow" viewBox="0 0 14 12">
                        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/static/img/svg/sprite.svg#icon-arrow"></use>
                    </svg>
                </a>
            <%}%>`;

        this._activateTagFilter();
    }

    _activateTagFilter() {
        const self = this;
        $old('.select2').on('change', function () {
            var params = new URLSearchParams(window.location.search);
            const val = $(this).val();

            if (val) {
                params.set('tags', val);
            } else {
                params.delete('tags');
            }

            // Reset page to 1 when filter is active
            params.set("page", 1);

            self._updateUrl(params);
            self._doSearch(params);
        });
    }

    _activateFilter() {
        const self = this;

        for (var i = 0; i < this.filterItems.length; i += 1) {
            this.filterItems[i].addEventListener("change", function (e) {

                const filterType = this.getAttribute("name");
                const filterValue = this.options[this.selectedIndex].value;

                let params = self._getParams();

                if (filterValue) {
                    params.set(filterType, filterValue);
                    // Reset page to 1 when filter is active
                    params.set("page", 1);
                } else {
                    params.delete(filterType);
                }

                self._updateUrl(params);
                self._doSearch(params);
            });
        }
    }

    _doSearch(params) {
        if (typeof window.pageGuid !== "undefined") {
            params.set("pageGuid", window.pageGuid);
        }
        axios
            .get("/api/eventsearch", { params: params })
            .then(this._handleResponse.bind(this))
            .catch(this._catch);
    }

    _initializeEventListeners() {
        const self = this;

        this.paginationDirection = document.getElementsByClassName(
            "pagination-link--direction"
        );
        this.paginationNumbers = document.getElementsByClassName(
            "pagination-link--number"
        );
        for (let i = 0, l = this.paginationDirection.length; i < l; i++) {
            this._initializeDirectionalButtons(this.paginationDirection[i]);
        }

        for (let i = 0, l = this.paginationNumbers.length; i < l; i++) {
            this._initializeNumberButtons(this.paginationNumbers[i]);
        }
    }

    _initializeNumberButtons(element) {
        const self = this;

        element.addEventListener("click", function (e) {
            if (this.classList.contains("pagination-link--disabled")) {
                return;
            }

            const params = self._getParams();
            const pageNumber = parseInt(this.innerHTML);

            params.set("page", pageNumber);

            self._updateUrl(params);
            self._doSearch(params);
        });
    }

    _initializeDirectionalButtons(element) {
        const self = this;

        element.addEventListener("click", function (e) {
            if (this.classList.contains("pagination-link--disabled")) {
                return;
            }

            const params = self._getParams();
            const direction = this.getAttribute("data-direction");

            if (direction === "back") {
                if (params.has("page")) {
                    params.set("page", parseInt(params.get("page")) - 1);
                }
            } else {
                if (params.has("page")) {
                    params.set("page", parseInt(params.get("page")) + 1);
                } else {
                    params.set("page", 2);
                }
            }

            self._updateUrl(params);
            self._doSearch(params);
        });
    }

    _getParams() {
        return new URLSearchParams(window.location.search);
    }

    _catch(errorResponse) {
        console.error(errorResponse);
    }

    _updateUrl(params) {
        const questionMark = params.toString() !== "" ? "?" : "";
        window.history.replaceState(
            {},
            "",
            `${location.pathname}${questionMark}${params}`
        );
    }

    _handleResponse(response) {
        this._updatePagination(response.data);

        if (response.data.Results !== isNullOrUndefined) {
            this._updateSearchResults(response.data.Results);
            return;
        }

        console.error("Error handling response: ");
        console.error(response);
    }

    _updatePagination(responseData) {
        var start =
            responseData.SelectedPage -
            (8 - (responseData.TotalPages - responseData.SelectedPage));
        start = start < 1 ? 1 : start;

        var end = 9 < responseData.TotalPages ? 9 : responseData.TotalPages;

        const html = TemplateEngine(this.paginationTemplate, {
            selectedPage: responseData.SelectedPage,
            totalPages: responseData.TotalPages,
            start: start,
            end: end,
            resultCount: responseData.Results ? responseData.Results.length : 0
        });

        document.getElementById("pagination").innerHTML = html;
    }

    _updateSearchResults(resultList) {
        const html = TemplateEngine(this.template, {
            results: resultList
        });

        var eventsFound = document.getElementById('no-events-found-message');

        if (resultList != null && resultList.length > 0) {
            eventsFound.style.display = "none";
        } else {
            eventsFound.style.display = "block";
        }

        document.getElementById("result-list").innerHTML = html;
        this._initializeEventListeners();
    }

    _toggleFilters() {
        this.searchFiltersTrigger.addEventListener("click", () => {
            this.searchFilters.classList.toggle("search-filters--active");

            const filterType = this.getAttribute("data-filter-type");

            let params = self._getParams();

            if (params.has(filterType) === true) {
                params.delete(filterType);
                window.history.replaceState({}, "", `${location.pathname}?${params}`);
            }
        });
    }
}
